export default function isEmpty(data) {
  if (!data) return true;

  return [Object, Array].includes(data.constructor) && !Object.entries(data).length;
}
